// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2009cbfe","513":"3e507183","703":"048e4a97","787":"a0b27b20"}[chunkId] + ".chunk.js";
};